"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
/** Здесь или в раздельных файлах нужно сохранять специфичные для панели вещи */
/** Спорное решение IMHO */
__exportStar(require("./moderation"), exports);
__exportStar(require("./panel-account"), exports);
__exportStar(require("./panel-collection"), exports);
__exportStar(require("./panel-content"), exports);
__exportStar(require("./panel-difficulty-level"), exports);
__exportStar(require("./panel-difficulty-level-category"), exports);
__exportStar(require("./panel-meeting"), exports);
__exportStar(require("./panel-user-service"), exports);
